import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;

export function useMode() {
  const [mode, setMode] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api("/web/mode").then((d) => { cached = d; setMode(d); }).catch(() => setMode({ mode: "upstream" }));
  }, []);
  return mode;
}
